import { CalibrationDeviceRailDeviceRow } from '@/features/calibration/components/CalibrationDeviceRailDeviceRow';
import { CalibrationDeviceRailFooterRow } from '@/features/calibration/components/CalibrationDeviceRailFooterRow';
import { CalibrationDeviceRailStateRow } from '@/features/calibration/components/CalibrationDeviceRailStateRow';
import { CalibrationDeviceRailStationRow } from '@/features/calibration/components/CalibrationDeviceRailStationRow';
import type {
  CalibrationDeviceTreeQuery,
  CalibrationDeviceTreeRow,
} from '@/features/calibration/types/calibrationDeviceTree';
import type { CSSProperties, Ref } from 'react';

export function CalibrationDeviceRailRow({
  row,
  activeDeviceId,
  onToggleStation,
  onRetryDeviceBranch,
  deviceQuery,
  measureRef,
  virtualIndex,
  style,
}: {
  row: CalibrationDeviceTreeRow;
  activeDeviceId?: string;
  onToggleStation: (stationId: string) => void;
  onRetryDeviceBranch: (stationId: string) => void;
  deviceQuery: CalibrationDeviceTreeQuery | undefined;
  measureRef: Ref<HTMLLIElement>;
  virtualIndex: number;
  style: CSSProperties;
}) {
  if (row.kind === 'station') {
    return (
      <CalibrationDeviceRailStationRow
        row={row}
        onToggleStation={onToggleStation}
        measureRef={measureRef}
        virtualIndex={virtualIndex}
        style={style}
      />
    );
  }

  if (row.kind === 'device') {
    return (
      <CalibrationDeviceRailDeviceRow
        row={row}
        activeDeviceId={activeDeviceId}
        measureRef={measureRef}
        virtualIndex={virtualIndex}
        style={style}
      />
    );
  }

  if (row.kind === 'device-state') {
    return (
      <CalibrationDeviceRailStateRow
        row={row}
        onRetryDeviceBranch={onRetryDeviceBranch}
        measureRef={measureRef}
        virtualIndex={virtualIndex}
        style={style}
      />
    );
  }

  return (
    <CalibrationDeviceRailFooterRow
      row={row}
      deviceQuery={deviceQuery}
      measureRef={measureRef}
      virtualIndex={virtualIndex}
      style={style}
    />
  );
}
